import React, { memo } from 'react';
import Skeleton from './Skeleton';

const TableSkeleton = memo(function TableSkeleton({ rows = 5, columns = 5, showHeader = true, style = {} }) {
  return (
    <div
      aria-busy="true"
      style={{
        background: '#FFFFFF',
        borderRadius: 14,
        border: '1.5px solid var(--border, #E5E7EB)',
        overflow: 'hidden',
        width: '100%',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        ...style,
      }}
    >
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        {showHeader && (
          <thead>
            <tr style={{ background: 'var(--cream, #FAF8F3)', borderBottom: '1.5px solid var(--border, #E5E7EB)' }}>
              {Array.from({ length: columns }).map((_, cIdx) => (
                <th key={cIdx} style={{ padding: '14px 16px', textAlign: 'left' }}>
                  <Skeleton
                    variant="text"
                    width={cIdx === 0 ? 120 : cIdx === columns - 1 ? 60 : 90}
                    height={14}
                  />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {Array.from({ length: rows }).map((_, rIdx) => (
            <tr
              key={rIdx}
              style={{
                borderBottom: rIdx < rows - 1 ? '1px solid var(--border, #E5E7EB)' : 'none',
              }}
            >
              {Array.from({ length: columns }).map((_, cIdx) => (
                <td key={cIdx} style={{ padding: '14px 16px' }}>
                  {cIdx === 0 ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <Skeleton variant="rectangular" width={32} height={32} borderRadius={6} />
                      <div>
                        <Skeleton variant="text" width={140} height={14} style={{ marginBottom: 4 }} />
                        <Skeleton variant="text" width={80} height={10} />
                      </div>
                    </div>
                  ) : cIdx === columns - 1 ? (
                    <Skeleton variant="rectangular" width={70} height={28} borderRadius={8} />
                  ) : (
                    <Skeleton
                      variant="text"
                      width={cIdx % 2 === 0 ? 80 : 110}
                      height={14}
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default TableSkeleton;
